export enum CourseChapterType {
  TEXT = 0,
  AUDIO = 1,
  PRESENTATION = 2,
  QUIZ = 3,
  MEDIA = 4
}

export type CourseChapter = {
  type: CourseChapterType
  name?: string
  quiz_id?: string
  timecode?: number
  auto_open?: boolean
  // link?: string
}

export enum CourseLocationType {
  OFFLINE = 0,
  ONLINE = 1,
  VIDEO = 2,
}

export type Course = {
  id?: string
  name: string
  // short_description: string
  long_description: string


  author_image_url?: string
  author_name: string
  author_bio: string

  timestamp?: string
  end_timestamp?: string
  location?: string
  video_blob_id?: string
  location_type: CourseLocationType

  contents: CourseChapter[]

  attachments?: CourseAttachment[]
  disable_certificate?: boolean
  disable_rewind_lock?: boolean
  special?: boolean
  priority?: number
  last_chapter_early_certificate?: boolean
}

export type CourseViewerInfo = {
  course_id: string
  user_id: string
  max_timecode: number
  completed_quizzes: string[]
  course_completed: boolean
}

export type CourseAttachment = {
  // On the client used to mark the multipart names,
  // on the server used to mark a unique attachment
  // (blob_id's are not validated to be used once)
  id: string
  name: string
  blob_id?: string
}
